import { useState } from "react";
import { joinViaInvite } from "../bootstrap";
import { describeError, t } from "../i18n";
import type { AppSession } from "../bootstrap";

/**
 * The landing page for an invite link.
 *
 * Asking for a name is not ceremony: on a callout map every pin is captioned
 * with who placed it, so a room full of "Guest" would defeat the point.
 */
export function InviteJoin({ code, onJoined }: { code: string; onJoined: (session: AppSession) => void }) {
  const [name, setName] = useState(() => window.localStorage.getItem("callout:name") ?? "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const join = async () => {
    const trimmed = name.trim();
    if (trimmed.length === 0) {
      setError(t("error.needName"));
      return;
    }
    setBusy(true);
    setError(null);
    try {
      onJoined(await joinViaInvite(code, trimmed));
    } catch (failure) {
      setError(describeError(failure, "join.failed"));
      setBusy(false);
    }
  };

  return (
    <div className="boot">
      <div className="join">
        <h1>{t("join.title")}</h1>
        <p className="join__lede">
          {t("join.lede")}
        </p>
        <input
          className="join__input"
          value={name}
          maxLength={24}
          placeholder={t("join.name")}
          autoFocus
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && void join()}
        />
        {error && <p className="feedback__error">{error}</p>}
        <button type="button" className="join__go" onClick={() => void join()} disabled={busy}>
          {busy ? t("join.joining") : t("join.go")}
        </button>
      </div>
    </div>
  );
}
